export enum PageClientType {
    Page = 'page',
    /**
     * @deprecated This value is deprecated and should not be used in new implementations.
     */
    PagePersist = 'page-persist',
    None = 'none',
}
